class ExistingTaskListModel {
    constructor({status = null, message = null, taskList = []} = {}) {
        this.status = status;
        this.message = message;
        this.taskList = taskList.map((task) => new TaskList(task));
    }

    static fromJson(json) {
        return new ExistingTaskListModel({
            status: json.status ?? null,
            message: json.message ?? null,
            taskList: json.task_list
                ? json.task_list.map((task) => TaskList.fromJson(task))
                : [],
        });
    }

    toJson() {
        return {
            status: this.status,
            message: this.message,
            task_list: this.taskList.map((task) => task.toJson()),
        };
    }
}

class TaskList {
    constructor({
                    id = null,
                    taskName = null,
                    locationId = null,
                    orderCount = null,
                    driver = null,
                } = {}) {
        this.id = id;
        this.taskName = taskName;
        this.locationId = locationId;
        this.orderCount = orderCount;
        this.driver = driver;
    }

    static fromJson(json) {
        return new TaskList({
            id: json.id ?? null,
            taskName: json.task_name ?? null,
            locationId: json.location_id ?? null,
            orderCount: json.order_count ?? null,
            driver: json.driver ?? null,
        });
    }

    toJson() {
        return {
            id: this.id,
            task_name: this.taskName,
            location_id: this.locationId,
            order_count: this.orderCount,
            driver: this.driver,
        };
    }
}

export {ExistingTaskListModel, TaskList};
